export const STICKER_CATEGORIES = {
	all: "All",
	flags: "Flags",
	shapes: "Shapes",
};

export function isStickerCategory(value: string): value is keyof typeof STICKER_CATEGORIES {
	return value === "all" || value === "flags" || value === "shapes";
}
